export type PortalPayrollUpdateRowStatus =
  | "ACTUALIZADO"
  | "SIN CAMBIOS"
  | "NO ENCONTRADO"
  | "RUT INVÁLIDO"
  | "ERROR";

export interface PortalPayrollUpdateRow {
  rowNumber: number;
  rut: string;
  personaId?: string;
  status: PortalPayrollUpdateRowStatus;
  updatedFields: string[];
  unresolvedValues: string[];
  description: string;
}

export interface PortalPayrollUpdateSummary {
  total: number;
  updated: number;
  unchanged: number;
  notFound: number;
  invalid: number;
  failed: number;
  fieldsWritten: number;
}

export interface PortalPayrollUpdateResult {
  updateId: string;
  processId: string;
  summary: PortalPayrollUpdateSummary;
  rows: PortalPayrollUpdateRow[];
}

export const EMPTY_PORTAL_PAYROLL_UPDATE_SUMMARY: PortalPayrollUpdateSummary = {
  total: 0,
  updated: 0,
  unchanged: 0,
  notFound: 0,
  invalid: 0,
  failed: 0,
  fieldsWritten: 0,
};

export type PortalPayrollUpdateFilter = "all" | "updated" | "issues";

export const filterPortalPayrollUpdateRows = (
  rows: PortalPayrollUpdateRow[],
  filter: PortalPayrollUpdateFilter
): PortalPayrollUpdateRow[] => {
  if (filter === "updated") return rows.filter(({ status }) => status === "ACTUALIZADO");
  if (filter === "issues") {
    return rows.filter(
      ({ status, unresolvedValues }) =>
        status === "NO ENCONTRADO" ||
        status === "RUT INVÁLIDO" ||
        status === "ERROR" ||
        unresolvedValues.length > 0
    );
  }
  return rows;
};
